import { render, staticRenderFns } from "./LabelCategorySettingsOverviewItem.vue?vue&type=template&id=511150af&scoped=true&"
import script from "./LabelCategorySettingsOverviewItem.vue?vue&type=script&lang=js&"
export * from "./LabelCategorySettingsOverviewItem.vue?vue&type=script&lang=js&"
import style0 from "./LabelCategorySettingsOverviewItem.vue?vue&type=style&index=0&id=511150af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511150af",
  null
  
)

export default component.exports